import IService from 'interfaces/IService';
import RestService from './RestService';

export default class ServiceRestService extends RestService<IService> {
  constructor() {
    super('services');
  }
}
